import { Component, Input } from '@angular/core';
import { Platform } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CoNewsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-news',
  templateUrl: 'co-news.html'
})
export class CoNewsComponent {

  @Input() blockInfo: any;

  constructor(private platform: Platform, private inAppBrowser: InAppBrowser) {
  }

  ngOnInit() {
    // console.log(this.blockInfo);
  }

  openUrl(link) {
    if (!link) {
      return;
    }

    if (this.platform.is('core')) {
      // let modal = this.modalCtrl.create(CoTcModalPage, { url: this.currentItem.room.tcLink })
      // modal.present();
      window.open(link, '_blank');
      return;
    }

    this.inAppBrowser.create(link, '_top');
  }

}



// WEBPACK FOOTER //
// ./src/components/co-news/co-news.ts